import React, {useContext, useMemo} from "react";
import classnames from "classnames";
import {ContactPhone} from "./ContactPhone";
import {Images} from "../images/Images";
import {useWindowDimensions} from "../utils/hooks.jsx";
import "./contact-us-box.css";
import {AppContext} from "../AppContext.jsx";

export const ContactUsBox = () => {
    const {me, company} = useContext(AppContext);
    const {width} = useWindowDimensions();
    const isMobileView = useMemo(() => width < 800, [width]);

    return (
        <div
            className={classnames("contact-us-box-container", {isMobileView})}
            onClick={() =>
                ContactPhone.openWhatsApp(
                    ContactPhone.phoneNumber() || me?.assignedCSMs?.[0]?.phone || company?.assignedCSMs?.[0]?.phone
                )
            }>
            <img className="whatsapp-icon" src={Images.whatsapp} alt="whatsapp" />
        </div>
    );
};
